module.exports = __webpack_public_path__ + "img/10-1.3cfea7a5.png";